import { IconButton, Button, Dialog, DialogTitle, Stack, DialogContent, DialogActions, Typography, DialogContentText} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React , { useContext} from 'react'
import { color } from '@mui/system'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import ProfileSettings from '../views/common/profileSettings'
import {AuthUserContext} from "../providers/AuthProvider";


const Support = () => {
  const { profile } = useContext(AuthUserContext);
  const [open, setOpen] = React.useState(false)
  const openSupport = () => {
     setOpen(true)
  }
  return (
    <> 
    {profile?.userType=== "admin" ? <></> :
    <>
    <Button variant='contained' onClick={openSupport}
    sx={{position: 'fixed',
    bottom: 55, right: 55,
    minHeight: "60px", minWidth:"60px",
    borderRadius:'100%', backgroundColor:"#FD4A01"}}>
        <img src={"/assets/support.png"} alt="Support"/>
    </Button>  
    <Dialog
    open={open}
    onClose={() => setOpen(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth='lg'
    >
    <DialogTitle id="alert-dialog-title" >
      <Stack direction={'row'} spacing={2}>
        <Typography variant={'h6'} sx={{flex:1, textAlign:'left'}} color={'primary'}>Do you need help?</Typography>
        <IconButton color={'primary'} onClick={() => setOpen(false)}>
          <CloseIcon/>
        </IconButton>
      </Stack>


    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description" variant={'body1'}>
         You can contact the admin via email - <a style={{color:"GrayText"}} href='mailto:contact.us@risetv.co.uk'><b>contact.us@risetv.co.uk</b></a> - or phone - <b style={{color:"GrayText"}}>626-315-1219</b>.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{paddingX: 3, paddingY: 2}}>
      <Button  variant={'contained'} color={'warning'} align='right' sx={{paddingX: 3, backgroundColor: '#FD4A01'}} size={'small'} onClick={() => {
        setOpen(false);
      }}>
        Go Back
      </Button>
    </DialogActions>
  </Dialog>
  </>
}
  </>
  )
}

export default Support